import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// Returns: { mrr, arpa, churn, nrr, activation_rate, mrr_by_month: [{month, mrr}] }
function useSuperAdminMetrics() {
  return useQuery({
    queryKey: ["superadmin", "metrics"],
    queryFn: () => apiClient.get("/api/v1/superadmin/metrics/").then((r) => r.data),
    staleTime: 5 * 60 * 1000, // cached 5 min (backend caches in Redis — TASK-17)
  });
}

export { useSuperAdminMetrics };
